<div class="shell-content">
  @if (statusMeldung?.acf?.client) {
    <app-important-message></app-important-message>
  }
  <h3 class="header"> <!-- Header -->
    <div class="nav-logo" [routerLink]="'/'" routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
      <img alt="nv-logo" src="./assets/nv_logo.png"/>
      <div class="desktop bold">Meine NV</div>
    </div>

    <nav class="header-nav">
      <a class="header-element nav-link" [routerLink]="'/'" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: true}">
        <div>Übersicht</div>
      </a>
      <a class="header-element nav-link" [routerLink]="'/polizzen'" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: true}">
        <div>Polizzen</div>
      </a>
      <a class="header-element nav-link" [routerLink]="'/service'" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: true}">
        <div>Services</div>
      </a>
      <a class="header-element nav-link" [routerLink]="'/schaeden'" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: true}">
        <div>Schäden</div>
      </a>
      <a class="header-element nav-link" [routerLink]="'/mehr'" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: true}">
        <div>Mein Profil</div>
      </a>
      <div class="header-element header-button" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: true}">
        <koal-button class="desktop" [isNavButton]="true" [buttonTheme]="'default'" (clickEvent)="logout()"
                     text="Abmelden" leadingIcon="logout"></koal-button>
        <koal-button class="tablet" [isNavButton]="true" [buttonTheme]="'default'" (clickEvent)="logout()" text=""
                     leadingIcon="logout"></koal-button>
      </div>
    </nav>
  </h3>
  <div class="main-content-container">
    <div class="main-content">
      @if (currentUser()?.loggedInUser) {
        <div class="nav-bar-container">
          @if (currentBackURL()) {
            <app-navbar [backURL]="currentBackURL()"></app-navbar>
          }
        </div>
        <router-outlet></router-outlet>
      }
    </div>
  </div>

  <!--mobile footer navigation -->

  <nav class="footer"> <!-- Footer -->
    <div class="footer-element" [routerLink]="'/'" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      <span class="material-icons">home</span>
      <div>Übersicht</div>
    </div>
    <div class="footer-element" [routerLink]="'/polizzen'" routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
      <span class="material-icons">verified_user</span>
      <div>Polizzen</div>
    </div>
    <div class="footer-element" [routerLink]="'/service'" routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
      <span class="icon-spacer material-icons">verified_user</span>
      <div class="nv-logo-container">
        <img src="../../assets/nv_logo_stroke.png" height="32"/>
      </div>
      <div>Services</div>
    </div>
    <div class="footer-element" [routerLink]="'/schaeden'" routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
      <span class="material-icons">warning</span>
      <div>Schäden</div>
    </div>
    <div class="footer-element" [routerLink]="'/mehr'" routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
      <span class="material-icons">person</span>
      <div>Mein Profil</div>
    </div>
  </nav>
</div>
